"use client";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

import { handleShareModalOpened } from "@/src/store/listingDetail";
import { handleFavoriteModalOpened, handleListingFavorited, handleLastRemovedGroupInfo } from "@/src/store/favorite";
import { triggerInfoBarOpened, handleStickyContent } from "@/src/store/stickyInfoBar";

import { isTokenExpired, getNewToken, getToken } from "helpers/auth";
import { Ga4WithEventParameters } from "@/src/helpers/google-tag-manager/events/ga4-with-eventparameters";
import { favoriteHelpers } from "@/src/helpers/favorite";
import { runIdle } from "@/src/utils/idle-utils";

import { infoRemoveToListing } from "constants/favorite";

import HeartIcon from "assets/svg/heart.svg";
import HeartFullIcon from "assets/svg/heart_full.svg";
import ShareIcon from "assets/svg/share.svg";

import { removeFavoriteListing } from "services/favorites";

import Button from "components/common/button";
import LoginStepModalContent from "components/common/login-step-modal-content";
import ModalTextContent from "components/modal-text-content";

import styles from "./styles.module.css";

const Modal = dynamic(() => import("components/common/modal"), { ssr: false });

const BannerActionButtons = ({ listingId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const getAllFavoritesByAccount = favoriteHelpers();

  const isFavoritedListingReduxState = useSelector((state) => state.favorite.isFavoritedListing);

  const handleModalClose = () => setIsModalOpen(false);

  const handleLoginSuccessCallback = async () => {
    await getAllFavoritesByAccount((favoriteResponse) => {
      setIsModalOpen(false);
      const isFavorited = favoriteResponse?.some((group) => group.idList.includes(listingId));
      if (isFavorited) {
        dispatch(handleListingFavorited(true));
      } else {
        dispatch(handleFavoriteModalOpened());
      }
    });
  };

  const handleFavoriteButton = async () => {
    setTimeout(async () => {
      if (getToken()) {
        if (isTokenExpired()) await getNewToken();
        if (isFavoritedListingReduxState) {
          try {
            const response = await removeFavoriteListing(listingId);
            if (response.status === "success") {
              await getAllFavoritesByAccount((favoriteResponse) => {
                favoriteResponse.map(
                  (item) => item.idList.includes(listingId) && dispatch(handleListingFavorited(true))
                );
              });
              dispatch(handleListingFavorited(false));
              dispatch(handleStickyContent(infoRemoveToListing(response.result?.title)));
              dispatch(triggerInfoBarOpened());
              dispatch(handleLastRemovedGroupInfo(response.result));
            }
          } catch (error) {
            console.error(`Error for removing from favorite list! ${error}`);
          }
        } else {
          dispatch(handleFavoriteModalOpened());
        }
      } else {
        setIsModalOpen(true);
      }
    }, 0);

    runIdle(() => {
      Ga4WithEventParameters({
        eventName: "click_favorite",
        eventParameters: { item_id: listingId.toString() },
      });
    }, 1000);
  };

  useEffect(() => {
    if (!isFavoritedListingReduxState) {
      if (getToken())
        getAllFavoritesByAccount((favoriteResponse) => {
          favoriteResponse.map((item) => item.idList.includes(listingId) && dispatch(handleListingFavorited(true)));
        });
    }
  }, [isFavoritedListingReduxState]);

  return (
    <div className={styles.wrapper}>
      <Button outline onClick={handleFavoriteButton}>
        <span className={styles.iconWrap}>{isFavoritedListingReduxState ? <HeartFullIcon /> : <HeartIcon />}</span>
        Favori
      </Button>
      <Button outline onClick={() => dispatch(handleShareModalOpened())}>
        <span className={styles.iconWrap}>
          <ShareIcon />
        </span>
        Paylaş
      </Button>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} handleClose={() => handleModalClose()}>
          <ModalTextContent>
            <LoginStepModalContent handleLoginSuccessCallback={handleLoginSuccessCallback} />
          </ModalTextContent>
        </Modal>
      )}
    </div>
  );
};

BannerActionButtons.propTypes = {
  listingId: PropTypes.number,
};

export default BannerActionButtons;
